import { BILLING_RUN_STATUS, BILLING_RUN_TYPE } from 'src/features/billingRuns/utils/types';

export enum BILLING_ATTEMPT_STATUS {
    SUCCEEDED = 'succeeded',
    FAILED = 'failed',
    SKIPPED = 'skipped',
}

export enum BILLING_ATTEMPT_ERROR_CODE {
    NO_BILLING_POLICY = 'no_billing_policy',
    NO_PRICING_POLICY = 'no_pricing_policy',
    ALREADY_CHARGED = 'already_charged',
    NO_BILLING_ENTITY = 'no_billing_entity',
    NO_ACCOUNTING_RANGE = 'no_accounting_range',
    NO_ACCOUNTING_HEADING = 'no_accounting_heading',
    NO_UNIT = 'no_unit',
    NO_TAX_REASON = 'no_tax_reason',
    NEGATIVE_DOCUMENT_TOTAL = 'negative_document_total',
    UNEXPECTED_ERROR = 'unexpected_error',
}

/**
 * One record per unit of work - a subscription item for charging, a customer for invoicing.
 * Successes are recorded too, so this answers "did subscription X bill in March".
 *
 * Note which relations are nested and which are bare UUIDs: the brief calls all five nested, but
 * only `billing_run`, `subscription_item` and `customer` actually are.
 */
export type BillingAttempt = {
    id: string;
    created_at: string;
    modified_at: string;
    type: BILLING_RUN_TYPE;
    status: BILLING_ATTEMPT_STATUS;
    billing_period_start: string | null;
    /** Null on success. */
    error_code: BILLING_ATTEMPT_ERROR_CODE | null;
    /** Free text; may contain a traceback. Render verbatim, never parse. */
    error_detail: string | null;
    billing_run: {
        id: string;
        type: BILLING_RUN_TYPE;
        status: BILLING_RUN_STATUS;
        business_date: string;
    } | null;
    subscription_item: {
        id: string;
        subscription: {
            id: string;
            reference: string;
        };
        service_plan_item: {
            id: string;
            name: string;
        };
    } | null;
    customer: {
        id: string;
        name: string;
    } | null;
    /** Bare UUIDs, not nested - available for filtering, not for linking (no label to show). */
    subscription: string | null;
    charge: string | null;
    financial_document: string | null;
};
